export const signatureParkingStyles = {
	header: {
		backgroundColor: '#121212',
	},
	sidebar: {
		backgroundColor: '#121212',
		color: 'white',
	},
	button: {
		backgroundColor: '#EFBF04',
		border: '4px solid #EFBF04',
		borderWidth: '4px',
		borderRadius: '22px',
		fontWeight: 600,
		color: '#393839',
		':hover': {
			color: '#FFFFFF',
			backgroundColor: '#EFBF04',
			borderColor: '#EFBF04',
		},
	},
	title: {
		color: 'white',
	},
	outlinedButton: {
		border: '4px solid #faaf40',
		':hover': {
			border: '4px solid #faaf40',
		},
	},
	text: {
		color: '#121212',
	},
	table: {
		headerBackgroundColor: '#f2f2f2',
		headerTextColor: '#FFFFFF',
	},
	platformName: {
		name: 'Signature Parking Platform',
	},
	logo: {
		small: {
			src: '/signature/signature-icon.png',
			height: 40,
			width: 40,
		},
		large: {
			src: '/signature/signature-logo.png',
			height: 65,
			width: 135,
		},
	},
	favicon: {
		src: '/signature/signature-icon.png',
	},
	socials: {},
	siteUrl: 'https://www.signatureparkingtn.com/',
	orgName: 'Signature Parking',
};
